import * as z from 'zod';

const AUTH_TOKENS_STORAGE_KEY = 'tixbase.auth.tokens';

const tokensSchema = z.object({
  accessToken: z.string().min(1),
  refreshToken: z.string().min(1),
});

export type StoredTokens = z.infer<typeof tokensSchema>;

export const tokenStorage = {
  get(): StoredTokens | null {
    const raw = localStorage.getItem(AUTH_TOKENS_STORAGE_KEY);

    if (raw === null)
      return null;

    try {
      return tokensSchema.parse(JSON.parse(raw));
    } catch {
      localStorage.removeItem(AUTH_TOKENS_STORAGE_KEY);
      return null;
    }
  },

  set(tokens: StoredTokens): void {
    localStorage.setItem(AUTH_TOKENS_STORAGE_KEY, JSON.stringify(tokens));
  },

  clear(): void {
    localStorage.removeItem(AUTH_TOKENS_STORAGE_KEY);
  },

  subscribe(listener: (tokens: StoredTokens | null) => void): () => void {
    const onStorageChange = (event: StorageEvent) => {
      if (event.storageArea !== localStorage)
        return;

      if (event.key !== null && event.key !== AUTH_TOKENS_STORAGE_KEY)
        return;

      listener(tokenStorage.get());
    };

    window.addEventListener("storage", onStorageChange);

    return () => window.removeEventListener("storage", onStorageChange);
  },
};
